// extracted by mini-css-extract-plugin
module.exports = {"container":"FormattedPostText_container__ru-Cz","postText":"FormattedPostText_postText__3FjUv","fullName":"FormattedPostText_fullName__3_JNu"};